<template>
  <div class="treatments">
    <div>
      <!-- <div class="contact-section">
        <div id="breadcrumbs">
          <nav class="breadcrumbs">
            <span class="breadcrumbs-item">
              <a href="/">
                <span>{{ $t('new.home') }}</span>
              </a>
            </span>
            <span class="breadcrumb-divider" aria-hidden="true">/</span>
          </nav>
        </div>
      </div> -->
      <div class="about-banner">
        <img v-if="!isTablet || !isMobile"
          :src="bannerList[0]?.img || require('../../assets/assetsNew/about/banner.png')" />
        <div class="background" :class="{ 'mobile-bg': isTablet || isMobile }"></div>
        <div class="left-text">
          <h1 class="h1">{{ bannerList[0]?.title }}</h1>
          <h1 class="h1">{{ bannerList[0]?.subheading }}</h1>
          <h1 class="h1">{{ bannerList[0]?.three_title }}</h1>
        </div>
      </div>
      <div class="section">
        <h2>{{ topTab?.title }}</h2>
        <div class="sectionlist" v-if="isDesktop">
          <div class="section-item" v-for="(item, index) in topTab?.contentt" :key="index">
            <h3>{{ item?.title }}</h3>
            <div class="section-p">
              <p v-html="item?.content"></p>
              <!-- <p>KOMO redefines scalp care beyond traditional wash or massage - we bring together science,herbal
                expertise, and Al technology to create a new standard of scalp wellness.</p> -->
            </div>
          </div>

          <!-- <div class="section-item">
            <h3>Mission</h3>
            <div class="section-p">
              <p>KOMO redefines scalp care beyond traditional wash or massage - we bring together science,herbal
                expertise, and Al technology to create a new standard of scalp wellness.</p>
            </div>
          </div>
          <div class="section-item">
            <h3>Proposition</h3>
            <div class="section-p">
              <p>More than visible results, KOMO delivers professional trust, empowering customers to feel both healthy
                and confident.</p>
            </div>
          </div>
          <div class="section-item">
            <h3>Vision</h3>
            <div class="section-p">
              <p>To become global leading scalp and hair wellness brand, setting the benchmark through standardized SOPs
                and building an entrusted international brand in scalp care.</p>
            </div>
          </div> -->
        </div>
        <!-- 平板和移动端：轮播图 -->
        <div v-else class="section-carousel">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in topTab?.contentt" :key="index">
              <div class="section-item">
                <h3>{{ item?.title }}</h3>
                <div class="section-p">
                  <p v-html="item?.content"></p>
                </div>
              </div>
            </swiper-slide>
            <!-- <swiper-slide>
              <div class="section-item">
                <h3>Mission</h3>
                <div class="section-p">
                  <p>KOMO redefines scalp care beyond traditional wash or massage - we bring together science,herbal
                    expertise, and Al technology to create a new standard of scalp wellness.</p>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide>
              <div class="section-item">
                <h3>Proposition</h3>
                <div class="section-p">
                  <p>More than visible results, KOMO delivers professional trust, empowering customers to feel both
                    healthy and confident.</p>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide>
              <div class="section-item">
                <h3>Vision</h3>
                <div class="section-p">
                  <p>To become global leading scalp and hair wellness brand, setting the benchmark through standardized
                    SOPs and building an entrusted international brand in scalp care.</p>
                </div>
              </div>
            </swiper-slide> -->

            <!-- 分页器 -->
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

      </div>
      <div class="secondImg">
        <div class="left-img">
          <img :src="companyIntrotuction?.img || require('../../assets/assetsNew/home/homeAbout.png')" alt="" />
        </div>
        <div class="right-background">
          <div class="right-text">
            <h2>{{ companyIntrotuction?.content_title }}</h2>
            <h5> {{ companyIntrotuction?.conttent_content }}</h5>
          </div>
        </div>
      </div>
      <div class="third">
        <h2>{{ serviceIdea?.title }}</h2>
        <h5>{{ serviceIdea?.subheading }}</h5>
      </div>
      <div class="thirdlist">
        <div class="thirdItem" v-for="(item, index) in serviceIdea?.content" :key="index">
          <img :src="item?.img" alt="" />
          <div class="text">{{ item?.title }}</div>
        </div>

        <!-- <div class="thirdItem">
          <img src="../../assets/assetsNew/about/health.png" alt="" />
          <div class="text">Health</div>
        </div>
        <div class="thirdItem">
          <img src="../../assets/assetsNew/about/Joy.png" alt="" />
          <div class="text">Joy</div>
        </div>
        <div class="thirdItem">
          <img src="../../assets/assetsNew/about/Beauty.png" alt="" />
          <div class="text">Beauty</div>
        </div>
        <div class="thirdItem">
          <img src="../../assets/assetsNew/about/Vitality.png" alt="" />
          <div class="text">Vitality</div>
        </div> -->
      </div>
      <div class="fourth">
        <div class="fourth-top">
          <h2>{{ teamMessage?.title }}</h2>
          <h5>{{ teamMessage?.subheading }}</h5>
        </div>
        <div class="fourthlist" v-if="teamMessage && teamMessage.content">
          <div class="fourthItem" v-for="(item, index) in teamMessage?.content" :key="index">
            <img :src="item?.avatar" alt="" />
            <h3><strong>{{ item?.name }}</strong></h3>
            <h6><strong>{{ item?.title }}</strong></h6>
            <p v-html="item.content"></p>
            <!-- <p>
              "At KOMO, we believe that scalp health is the root of true beauty. My vision has always been to integrate
              science and refinement into a global standard of scalp care. Together with our
              team, we are building not just the KOMO brand, but a movement that redefines how the world cares for scalp
              and hair."
            </p> -->

          </div>
          <!-- <div class="fourthItem">
            <img src="../../assets/assetsNew/about/wang.png" alt="" />
            <h3><strong>Dr. Deyou Wang</strong></h3>
            <h6><strong>Founder of KOMO</strong></h6>
            <p>
              "At KOMO, we believe that scalp health is the root of true beauty. My vision has always been to integrate
              science and refinement into a global standard of scalp care. Together with our
              team, we are building not just the KOMO brand, but a movement that redefines how the world cares for scalp
              and hair."
            </p>
          </div>
          <div class="fourthItem">
            <img src="../../assets/assetsNew/about/lu.png" alt="" />
            <h3><strong>Dr. Lu</strong></h3>
            <h6><strong>R&D Director & Chief Scientist</strong></h6>
            <p>
              "At KOMO, we believe that scalp health is the root of true beauty. My vision has always been to integrate
              science and refinement into a global standard of scalp care. Together with our
              team, we are building not just the KOMO brand, but a movement that redefines how the world cares for scalp
              and hair."
            </p>
          </div>
          <div class="fourthItem">
            <img src="../../assets/assetsNew/about/kang.png" alt="" />
            <h3><strong>Dr. Kang</strong></h3>
            <h6><strong>Chief Scalp & Hair Research Officer</strong></h6>
            <p>
              "Scalp and hair research is at the heart of KOMO. We explore everything from follicle biology to the scalp
              microbiome, ensuring that every innovation is backed by rigorous science. Our
              goal is to unlock healthier, stronger, and more confident lives through scalp care."
            </p>
          </div> -->
        </div>
      </div>
    </div>

  </div>

</template>

<script>
// 导入 vue-awesome-swiper
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { getBannerListing, getDataList } from '@/api/komo'
export default {
  name: 'about',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      bannerList: [],
      aboutList: [],
      topTab: {},
      companyIntrotuction: {},
      serviceIdea: {},
      teamMessage: {},
      screenWidth: window.innerWidth,
      // Swiper 配置
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoHeight: true  // 自动高度
      },
      observer: null
    }
  },

  computed: {
    isDesktop() {
      return this.screenWidth >= 1000;
    },
    isTablett() {
      return this.screenWidth >= 768 && this.screenWidth < 1000;
    },
    isTablet() {
      return this.screenWidth >= 545 && this.screenWidth < 768;
    },
    isMobile() {
      return this.screenWidth < 545;
    },
    // Swiper 实例
    swiper() {
      return this.$refs.mySwiper.$swiper
    }

  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.animateText()
    // 确保 Swiper 初始化
    this.$nextTick(() => {
      if (this.$refs.mySwiper) {
        this.$refs.mySwiper.$swiper.update();
      }
    });
    // 初始化滚动动画观察器
    // this.$nextTick(() => {
    //   this.initScrollAnimation();
    // });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  async created() {
    await this.initData();
  },
  methods: {
    async initData() {
      const result = await getBannerListing('2');
      this.bannerList = result?.data?.list || [];
      console.log('Banner数据:', this.bannerList);
      const aboutDatalist = await getDataList(localStorage.getItem('pageId'));
      this.aboutList = aboutDatalist.data.list;
      this.topTab = this.aboutList
        .find(item => item.code === 'top_tab')
        ?.value?.[0] ?? {};
      this.companyIntrotuction = this.aboutList
        .find(item => item.code === 'company_introtuction')
        ?.value?.[0] ?? {};
      this.serviceIdea = this.aboutList
        .find(item => item.code === 'service_idea')
        ?.value?.[0] ?? {};
      this.teamMessage = this.aboutList
        .find(item => item.code === 'team_message')
        ?.value?.[0] ?? {};
      console.log('aboutData:', this.teamMessage);
      this.$nextTick(() => {
        this.initScrollAnimation();
      });
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      // 重新初始化滚动动画观察器
      this.$nextTick(() => {
        if (this.observer) {
          this.observer.disconnect();
        }
        this.initScrollAnimation();
      });
    },
    animateText() {
      const bannerImg = document.querySelector('.about-banner img');
      bannerImg.style.transform = 'scale(1.1)';
      bannerImg.style.opacity = '0';
      const textLines = document.querySelectorAll('.h1');
      textLines.forEach(line => {
        line.style.opacity = '0';
        line.style.transform = 'translateY(20px)';
      });
      setTimeout(() => {
        bannerImg.style.transition = 'all 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        bannerImg.style.opacity = '1';
        bannerImg.style.transform = 'scale(1)';
      }, 500);
      // 逐行显示动画
      textLines.forEach((line, index) => {
        setTimeout(() => {
          line.style.transition = 'all 0.8s ease'
          line.style.opacity = '1';
          line.style.transform = 'translateY(0)';
        }, index * 600); // 每行延迟时间递增，实现逐行显示效果
      })
    },
    initScrollAnimation() {
      // 创建 Intersection Observer
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 当元素进入视口时添加动画类
            entry.target.classList.add('animate');
            // 特别处理 left-img 的图片放大效果
            // if (entry.target.classList.contains('left-img')) {
            //   const img = entry.target.querySelector('img');
            //   if (img) {
            //     // 先放大图片
            //     img.style.transform = 'scale(1.2)';
            //     // 然后回到原始大小
            //     setTimeout(() => {
            //       img.style.transition = 'transform 1s ease';
            //       img.style.transform = 'scale(1)';
            //     }, 100);
            //   }
            // }
          }
          else {
            // 当元素离开视口时移除动画类（可选）
            entry.target.classList.remove('animate');
          }
        });
      }, {
        threshold: 0.3, // 当元素30%进入视口时触发
        rootMargin: '0px 0px -50px 0px' // 底部偏移，提前触发
      });

      // 观察所有需要动画的元素
      const animateElements = document.querySelectorAll('.section-item, .thirdItem, .fourthItem,.right-text,.third,.fourth-top,.fourthItem,.left-img,.left-text');
      animateElements.forEach(el => {
        this.observer.observe(el);
      });
    }
  }

}
</script>

<style scoped lang="scss">
.treatments {
  padding: var(--nav-max-height) 0 0;
  display: block;
  width: 100%;
  height: 100%;
}

.contact-section {
  width: 100%;

  #breadcrumbs {
    margin: 0;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 60px;
    padding-right: 60px;

    .breadcrumbs {
      font-size: 0;

      .breadcrumbs-item {
        margin-right: 10px;
        display: inline-block;
        font-size: 12px;

        a {
          color: var(--font-color);

          span {
            display: inline-block;
            padding-bottom: 0;
            font-family: var(--label-font-stack);
            font-weight: var(--label-font-weight);
            font-style: var(--label-font-style);
            text-transform: var(--label-font-case);
            letter-spacing: var(--label-spacing);
          }
        }
      }

      .breadcrumb-divider {
        font-size: 12px;
      }
    }
  }
}

.home {
  padding: 1% 5%;
  font-size: 0.3rem;
}

.about-banner {
  max-width: 100%;
  /* 移除固定高度，让图片保持比例 */
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

/* 背景样式 */
.background {
  display: none;
  /* 默认隐藏 */
}

/* 移动端背景样式 */
.background.mobile-bg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(239, 205, 151, 1);
  /* 你之前设置的颜色 */
  z-index: 1;
}

.left-text {
  position: absolute;
  left: 5%;
  bottom: 5%;
  font-size: 42px;
  color: #ffffff;
  font-weight: bold;
  line-height: normal;
  opacity: 0;
  transform: translateY(50px);
  /* 动画过渡 */
  transition: all 0.8s ease;
  margin-right: 10px;
}

.left-text.animate {
  opacity: 1;
  transform: translateY(0);
}

/* 三行文字的层级样式 */
.h1 {
  /* line-height: 1.2; */
  /* 初始动画状态 */
  opacity: 0;
  transform: translateY(20px);
  font-family: "Crimson Text", serif;
}

.about-banner img {
  /* 关键修复：确保图片等比例缩放 */
  max-width: 190%;
  height: auto;
  display: block;
  margin-left: -150px;
}

h2 {
  font-family: "Crimson Text", serif;
}

.section {
  padding: 60px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sectionlist {
  display: flex;
  // align-items: center;
  justify-content: center;
}

.section h2 {
  margin-bottom: 50px;
  font-size: 32px;
}

.section-item {
  font-size: 25px;
  color: rgba(66 43 32 / 1);
  /* 初始状态：隐藏并位于下方 */
  opacity: 0;
  transform: translateY(50px);
  /* 动画过渡 */
  transition: all 0.8s ease;
  margin-right: 10px;
  flex-shrink: 0;
  flex: 1;
}

/* 当元素进入视口时触发的动画 */
.section-item.animate {
  opacity: 1;
  transform: translateY(0);
}

.section-item h3 {
  font-family: "Crimson Text", serif;
  text-align: center;
  font-size: 25px;
}

.section-item:last-child {
  margin-right: 0;
}

.section-p {
  font-size: 15px;
  text-align: center;
  font-family: Inter, sans-serif;
}

.section-carousel {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

/* 轮播图中的项目样式 */
.section-carousel .section-item {
  opacity: 1;
  transform: none;
  animation: none;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  /* height: 250px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: none;
  text-align: center;
  margin: 0 10px;
}

.section-carousel .section-item h3 {
  font-size: 28px;
  margin-bottom: 20px;
  color: rgba(66, 43, 32, 1);
}

.section-carousel .section-p {
  font-size: 16px;
  line-height: 1.6;
  color: rgba(66, 43, 32, 0.8);
}

/* Swiper 分页器样式 */
:deep(.swiper-pagination-bullet) {
  width: 12px;
  height: 12px;
  background: #ddd;
  opacity: 1;
}

:deep(.swiper-pagination-bullet-active) {
  background: rgba(66, 43, 32, 1);
}

:deep(.swiper-pagination) {
  bottom: 10px !important;
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.secondImg {
  display: flex;
  /* 使用视口高度或最小高度 */
  height: 100vh;
  /*改为视口高度百分比*/
  min-height: 500px;
  /* 设置最小高度 */
  max-height: 750px;
  /* 设置最大高度 */
}

.left-img {
  width: 50%;
  position: relative;
  /* 为图片定位做准备 */
  overflow: hidden;
  /* 隐藏溢出的图片部分 */
  opacity: 0;
  /* transform: translateY(30px); */
  transition: all 0.8s ease;
}

.left-img.animate {
  opacity: 1;
  /* transform: translateY(0); */
}

.left-img img {
  max-width: 170%;
  /* 图片宽度填充容器 */
  height: 100%;
  /* 图片高度填充容器 */
  object-fit: cover;
  /* 关键：保持比例并覆盖整个容器 */
  display: block;
  /* 添加图片的过渡效果 */
  transition: transform 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  /* 初始状态稍微缩小，为放大动画做准备 */
  transform: scale(1.2);
}

/* 当 left-img 进入视口时，图片从放大状态缩小到正常 */
.left-img.animate img {
  transform: scale(1);
}

.right-background {
  background: rgba(100 113 93 / 1);
  width: 50%;
  height: 100%;
  position: relative;
}

.right-text {
  position: absolute;
  top: 50%;
  color: rgba(232 226 217 / 1);
  font-size: 15px;
  padding: 0 80px;
  opacity: 0;
  transform: translateY(calc(-50% + 30px));
  transition: all 0.8s ease;
}

.right-text.animate {
  opacity: 1;
  transform: translateY(-50%);
}

.right-text h2 {
  font-size: 28px;
  font-family: "Crimson Text", serif;
}

.right-text h5 {
  font-size: 15px;
  // font-family: "Crimson Text", serif;
  font-family: var(--body-font-stack);
}

.third {
  padding: 60px 60px 0 60px;
  font-size: 15px;
  color: rgba(66 43 32 / 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.third.animate {
  opacity: 1;
  transform: translateY(0);
}

.third h2 {
  font-family: "Crimson Text", serif;
  font-size: 30px;
}

.third h5 {
  font-family: "Crimson Text", serif;
  font-size: 18px;
}

.thirdlist {
  padding: 30px 60px 60px 60px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  /* max-width: 1600px; */
  height: auto;
}

.thirdlist img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 0;
  transition: transform 0.3s ease;
  /* 可选：添加悬停效果 */
}

.thirdItem {
  position: relative;
  flex: 1;
  /* 关键：使用 aspect-ratio 保持正方形 */
  aspect-ratio: 1 / 1;
  /* 宽高比 1:1，确保正方形 */
  width: 100%;
  /* 宽度自适应 */
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.thirdItem.animate {
  opacity: 1;
  transform: translateY(0);
}

.thirdItem:nth-child(1).animate {
  transition-delay: 0.1s;
}

.thirdItem:nth-child(2).animate {
  transition-delay: 0.2s;
}

.thirdItem:nth-child(3).animate {
  transition-delay: 0.3s;
}

.thirdItem:nth-child(4).animate {
  transition-delay: 0.4s;
}

.thirdlist .text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 30px;
  font-family: "Crimson Text", serif;
  z-index: 2;
  /* 确保文字在图片上方 */
  text-align: center;
  width: 100%;
  /* 确保文字容器宽度 */
  padding: 0 10px;
  /* 添加内边距防止文字贴边 */
  box-sizing: border-box;
}

.fourth {
  padding: 60px;
}

.fourth-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.fourth-top.animate {
  opacity: 1;
  transform: translateY(0);
}

.fourth h2 {
  font-family: "Crimson Text", serif;
  font-size: 28px;
}

.fourth h5 {
  font-family: "Crimson Text", serif;
  font-size: 18px;
}

.fourthlist {
  display: flex;
  gap: 60px;
  justify-content: center;
  height: auto;
  max-width: 600px;
  margin: 0 auto;
  /* 添加这行来居中 */
}

.fourthItem {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  max-width: 300px;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
  flex: 0 0 240px;
  text-align: center;
}

.fourthItem.animate {
  opacity: 1;
  transform: translateY(0);
}

.fourthItem:nth-child(1).animate {
  transition-delay: 0.1s;
}

.fourthItem:nth-child(2).animate {
  transition-delay: 0.2s;
}

.fourthItem:nth-child(3).animate {
  transition-delay: 0.3s;
}

.fourthItem img {
  max-width: 200px;
  min-width: 200px;
  min-height: 200px;
  max-height: 200px;
  display: inline-block;
  object-fit: contain;
  object-position: center;
  font-family: "object-fit: cover, object-position: center";
}

.fourthItem h3 {
  font-family: "Crimson Text", serif;
}

.fourthItem h6 strong {
  font-family: "Crimson Text", serif;
  font-size: 16px;
  color: rgba(66 43 32 / 1);
  text-transform: normal;
  font-style: normal;
}

.fourthItem p {
  font-family: Inter, sans-serif;
}

@media only screen and (min-width: 768px) {
  .breadcrumbs a {
    background-color: transparent !important;
    background-image: linear-gradient(to top, currentColor 0, currentColor 0), linear-gradient(to top, transparent 0, transparent 0);
    background-repeat: no-repeat;
    background-position: left bottom, left bottom;
    background-size: 0 1px, 100% 1px;
    transition-property: background-size;
    transition-timing-function: ease;
    transition-duration: .25s;
  }

  .breadcrumbs a:hover {
    background-position: left bottom, left bottom;
    background-size: 100% 1px, 100% 1px;
  }
}

@media (max-width: 1000px) {
  .fourthlist {
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 30px;
  }

  .thirdlist .text {
    font-size: 24px;
    /* 平板端文字稍小 */
  }

  .secondImg {
    height: 60vh;
    min-height: 400px;
  }
}

@media (max-width: 768px) {
  .fourthlist {
    flex-direction: column;
    align-items: center;
  }

  .third h2 {
    text-align: center;
  }

  .third h5 {
    text-align: center;
  }

  .thirdlist {
    padding: 30px 40px 60px 40px;
    /* 调整内边距 */
    gap: 8px;
    /* 缩小间距 */
    flex-wrap: wrap;
  }

  .thirdItem {
    /* 每行显示2个，每个占50%减去一半的gap */
    flex: 0 0 calc(50% - 4px);
    /* flex-grow, flex-shrink, flex-basis */
    aspect-ratio: 1 / 1;
  }

  .thirdlist .text {
    font-size: 20px;
  }

  .thirdlist img {
    width: 100%;
    height: 100%;
  }

  .about-banner {
    height: 40vh;
  }

  .background.mobile-bg {
    display: block;
    /* 显示背景 */
  }

  .left-text {
    font-size: 32px;
    z-index: 2;
    font-size: 24px;
    /* 可以适当调整移动端字体大小 */
    bottom: 10%;
    transform: translateY(-10%);
    left: 0;
  }

  .secondImg {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    flex-direction: column;
  }

  .left-img {
    width: 100%;
    height: 100vh;
    position: relative;
    /* 为图片定位做准备 */
    overflow: hidden;
    /* 隐藏溢出的图片部分 */
  }

  .left-img img {
    max-width: 170%;
    /* 图片宽度填充容器 */
    object-fit: cover;
    /* 关键：保持比例并覆盖整个容器 */
    display: block;
  }

  .right-background {
    padding: 80px 30px;
    background: rgba(100 113 93 / 1);
    width: 100%;
    // height: 20vh;
  }

  .right-text {
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% + 30px));
    color: rgba(232 226 217 / 1);
    font-size: 15px;
    padding: 0;
  }

  .right-text h2 {
    width: 100%;
    text-align: center;
    display: inline-block;
    font-size: 28px;
  }

  .right-text h5 {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .fourth-top h5{
    text-align: center;
  }
  .contact-section #breadcrumbs{
    padding: 15px;
  }
}

@media (max-width: 545px) {
  .fourthlist {
    flex-direction: column;
    align-items: center;
  }

  .thirdlist {
    width: 100%;
    padding: 30px 15px 60px 15px;
    flex-wrap: wrap;
    gap: 8px;
    /* 移动端间距更小 */
  }

  .thirdlist img {
    height: 100%;
    width: 100%;
  }

  .thirdItem {
    flex: 0 0 calc(50% - 4px);
    aspect-ratio: 1 / 1;
  }

  .thirdlist .text {
    font-size: 16px;
    /* 移动端文字更小 */
    padding: 0 5px;
    /* 移动端内边距更小 */
  }

  .about-banner {
    height: 40vh;
  }

  .background.mobile-bg {
    display: block;
    /* 显示背景 */
  }

  .left-text {
    bottom: 10%;
    transform: translateY(-10%);
    left: 0;
    font-size: 32px;
    z-index: 2;
    font-size: 16px;
    /* 可以适当调整移动端字体大小 */
  }

  .secondImg {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    flex-direction: column;
  }

  .left-img {
    width: 100%;
    height: 100vh;
    position: relative;
    /* 为图片定位做准备 */
    overflow: hidden;
    /* 隐藏溢出的图片部分 */
  }

  .left-img img {
    max-width: 170%;
    /* 图片宽度填充容器 */
    object-fit: cover;
    /* 关键：保持比例并覆盖整个容器 */
    display: block;
  }

  .right-background {
    padding: 15px 15px;
    background: rgba(100 113 93 / 1);
    width: 100%;
    // height: 40vh;
  }

  .right-text {
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% + 30px));
    color: rgba(232 226 217 / 1);
    font-size: 15px;
    padding: 0;
  }

  .right-text h2 {
    font-size: 28px;
    width: 100%;
    text-align: center;
    display: inline-block;
  }

  .right-text h5 {
    display: flex;
    justify-content: center;
    align-content: center;
  }
}

@media (max-width: 1115px) {
  .treatments {
    padding: var(--nav-1115-height) 0 0;
  }
}

@media (max-width: 990px) {
  .treatments {
    padding: var(--nav-990-height) 0 0;
  }
}
</style>